/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketing.asset.permissions.rpc.TeamPermissionsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getTeamIdsRpc = {
  serviceName: 'com.hubspot.marketing.asset.permissions.rpc.TeamPermissionsRpc',
  rpcName: 'getTeamIds',
  auth: 'app',
  fingerprint: 'pr9dNuLeadw5XRq1aW41GYyLzSMwKT7c',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateTeamIdsRpc = {
  serviceName: 'com.hubspot.marketing.asset.permissions.rpc.TeamPermissionsRpc',
  rpcName: 'updateTeamIds',
  auth: 'app',
  fingerprint: 'WMoMGF3eR_qOUe2e_r4XmYyLzSMwKT7c',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const assignDefaultTeamIdsRpc = {
  serviceName: 'com.hubspot.marketing.asset.permissions.rpc.TeamPermissionsRpc',
  rpcName: 'assignDefaultTeamIds',
  auth: 'app',
  fingerprint: 'w7C288rLLdqOUe2e_r4XmYyLzSMwKT7c',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const assignDefaultUserTeamIdsRpc = {
  serviceName: 'com.hubspot.marketing.asset.permissions.rpc.TeamPermissionsRpc',
  rpcName: 'assignDefaultUserTeamIds',
  auth: 'app',
  fingerprint: 'MHOjvkc2JfuOUe2e_r4XmYyLzSMwKT7c',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};